import { Card, CardProps } from '@chakra-ui/react';

export default function ContentPage({ children, ...props }: { children: React.ReactNode } & CardProps) {
  return (
    <Card variant={{ base: 'unstyled', md: 'outline' }} {...props}>
      {children}
    </Card>
  );
}
